import { useState, useCallback, Fragment, useMemo } from "react"
import { get } from "lodash"
import LanguageIcon from "@mui/icons-material/Language"
import {
  useTheme,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Avatar,
} from "@mui/material"
import { useTranslation } from "react-i18next"

import { useVenue } from "../../providers/venue"
import { gtmPushDataLayerSelectLanguage } from "utils/googletagmanager"
import { getIcon } from "utils/icon"

export const LanguageSelector = ({ onSwitchedLanguage }) => {
  const [open, setOpen] = useState(false)
  const { t, i18n } = useTranslation()
  const { locales, localeConfig } = useVenue()
  const theme = useTheme()
  const styleOverrides = theme.components[`AppSidebar`]?.styleOverrides || {}
  const {
    navList,
    navListItem,
    subListItem,
    subList,
    subDivider,
    flagIcon,
    navDivider,
    currentFlagIcon,
    fallbackFlagIcon,
  } = styleOverrides

  const flagCode = useMemo(
    () =>
      get(localeConfig, `${i18n.language}.flagCode`) ||
      get(localeConfig, `en.flagCode`),
    [localeConfig, i18n.language]
  )

  const switchLanguage = useCallback(
    (lang) => (e) => {
      i18n.changeLanguage(lang)
      gtmPushDataLayerSelectLanguage(lang)
      onSwitchedLanguage(lang)
    },
    [i18n, onSwitchedLanguage]
  )
  const languageIcon = useMemo(
    () => getIcon(theme?.assets?.languageButton) || <LanguageIcon />,
    [theme]
  )
  return (
    <List sx={navList} disablePadding>
      <ListItemButton onClick={(e) => setOpen(!open)} sx={navListItem}>
        <ListItemIcon sx={currentFlagIcon}>
          <Avatar
            src={`https://flagcdn.com/h40/${flagCode}.webp`}
            sx={flagIcon}
          >
            {languageIcon}
          </Avatar>
        </ListItemIcon>
        <ListItemIcon sx={fallbackFlagIcon}>{languageIcon}</ListItemIcon>
        <ListItemText primary={t("Languages")} />
      </ListItemButton>
      {open && <Divider sx={navDivider} />}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List sx={subList}>
          {locales.map((locale, index) => (
            <Fragment key={locale.localeKey}>
              <ListItemButton
                sx={subListItem}
                onClick={switchLanguage(locale.localeKey)}
              >
                <ListItemIcon>
                  <Avatar
                    src={`https://flagcdn.com/h40/${locale.flagCode}.webp`}
                    sx={flagIcon}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={t(
                    `localization.navigation.item.${locale.localeKey}`,
                    locale.localizedName
                  )}
                />
              </ListItemButton>
              <Divider sx={subDivider} />
            </Fragment>
          ))}
        </List>
      </Collapse>
    </List>
  )
}
